module.exports = __webpack_public_path__ + "f2492f3c1605c0bb1fe853dc39520939.pdf";